import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'react-i18next'
import { useAxiosPrivate, useToast } from 'shared/hooks'

type UseDeleteTypeMutationProps = {
	id: string | null
	onSettled: () => void
}

export const useDeleteTypeMutation = ({ id, onSettled }: UseDeleteTypeMutationProps) => {
	const { t } = useTranslation()
	const queryClient = useQueryClient()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: deleteTypeMutation } = useMutation({
		mutationFn: () => {
			return axiosPrivate.delete(apiRoutes.type(id!))
		},
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Type deleted')
			})()
			queryClient.invalidateQueries({ queryKey: queryKeys.types.all })
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		deleteTypeMutation
	}
}
